import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3ea91cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alerts"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_3 = {
  key: 1,
  class: "loader-wrapper"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-spinner icon" })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "alerts"
}
const _hoisted_8 = { class: "d-alerts-main" }
const _hoisted_9 = { class: "d-alerts-main__left" }
const _hoisted_10 = { class: "d-aside" }
const _hoisted_11 = { class: "d-aside__main-menu" }
const _hoisted_12 = { class: "d-alerts-main__right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "loader-wrapper"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-spinner icon" })
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_alerts_notification = _resolveComponent("alerts-notification")!
  const _component_app_no_message = _resolveComponent("app-no-message")!
  const _component_refresh_pull = _resolveComponent("refresh-pull")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_app_media_view = _resolveComponent("app-media-view")!
  const _component_app_file_view = _resolveComponent("app-file-view")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_drive_aside_main_menu = _resolveComponent("drive-aside-main-menu")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_container, { class: "container" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_header, null, {
              "top-left": _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "back-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", {
              class: "scroll",
              onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
              ref: "scroller"
            }, [
              _createVNode(_component_refresh_pull, {
                modelValue: _ctx.loadingPull,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loadingPull) = $event)),
                onRefresh: _ctx.onRefresh,
                successText: _ctx.successText,
                pullingText: _ctx.pullingText,
                loosingText: _ctx.loosingText,
                loadingText: _ctx.loadingText
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertStore.notifications.data, (notification) => {
                    return (_openBlock(), _createBlock(_component_alerts_notification, {
                      key: notification.creationDate,
                      notification: notification,
                      class: "notification"
                    }, null, 8, ["notification"]))
                  }), 128)),
                  (_ctx.alertStore.notifications.data.length === 0)
                    ? (_openBlock(), _createBlock(_component_app_no_message, {
                        key: 0,
                        icon: 'icon-no-alert'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('alerts.no.alerts')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isPageLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue", "onRefresh", "successText", "pullingText", "loosingText", "loadingText"])
            ], 544)
          ]),
          _: 1
        }),
        (_ctx.driveStore.appPhotoViewMedia)
          ? (_openBlock(), _createBlock(_component_app_media_view, {
              key: 0,
              onOnClose: _ctx.closeFullScreen
            }, null, 8, ["onOnClose"]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              (_ctx.driveStore.fullscreenFile)
                ? (_openBlock(), _createBlock(_component_app_file_view, {
                    key: 0,
                    onClose: _ctx.closeFullScreen
                  }, null, 8, ["onClose"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createVNode(_component_el_container, { class: "container" }, {
          default: _withCtx(() => [
            _createVNode(_component_desktop_header, { class: "d-header" }),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("aside", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_drive_aside_main_menu)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: "d-scroll",
                  onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                  ref: "scroller"
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)), ["prevent"])),
                    class: "close-link"
                  }, _hoisted_14),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertStore.notifications.data, (notification) => {
                    return (_openBlock(), _createBlock(_component_alerts_notification, {
                      key: notification.creationDate,
                      notification: notification,
                      class: "notification"
                    }, null, 8, ["notification"]))
                  }), 128)),
                  (_ctx.alertStore.notifications.data.length === 0)
                    ? (_openBlock(), _createBlock(_component_app_no_message, {
                        key: 0,
                        icon: 'icon-no-alert'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('alerts.no.alerts')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isPageLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                    : _createCommentVNode("", true)
                ], 544)
              ])
            ])
          ]),
          _: 1
        }),
        (_ctx.driveStore.appPhotoViewMedia)
          ? (_openBlock(), _createBlock(_component_app_media_view, {
              key: 0,
              onOnClose: _ctx.closeFullScreen
            }, null, 8, ["onOnClose"]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
              (_ctx.driveStore.fullscreenFile)
                ? (_openBlock(), _createBlock(_component_app_file_view, {
                    key: 0,
                    onClose: _ctx.closeFullScreen
                  }, null, 8, ["onClose"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
}